const STATUS_COLORS = {
  Saved: { color: '#448aff', backgroundColor: '#bbdefb' },
  HOLD: { color: '#d50000', backgroundColor: '#ffebee' },
  Booked: { color: '#9c27b0', backgroundColor: '#f3e5f5' },
  Delivered: { color: '#1b5e20', backgroundColor: '#c8e6c9' },
  InTransit: { color: '#e65100', backgroundColor: '#ffe0b2' },
  ApprovedForBooking: { color: '#0277bd', backgroundColor: '#e1f5fe' },
  Tendered: { color: '#e65100', backgroundColor: '#fff3e0' },
  NotApproved: { color: '#c62828', backgroundColor: '#ffebee' },
  Cancelled: { color: '#dc2626', backgroundColor: '#fef2f2' }
};

const FALLBACK_COLOR = { color: '#424242', backgroundColor: '#eeeeee' };

export const getShipmentStatusColor = shipmentStatus => {
  if (!shipmentStatus) return FALLBACK_COLOR;
  if (shipmentStatus.toUpperCase() === 'HOLD') return STATUS_COLORS.HOLD;
  return STATUS_COLORS[shipmentStatus] || FALLBACK_COLOR;
};
